var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373635",
    d: "M23.249 5.132a9.5 9.5 0 0 1-2.65.717 4.57 4.57 0 0 0 2.03-2.512c-.908.53-1.9.903-2.932 1.101A4.65 4.65 0 0 0 16.327 3c-2.552 0-4.616 2.034-4.616 4.542a4.4 4.4 0 0 0 .119 1.036A13.16 13.16 0 0 1 2.314 3.83a4.5 4.5 0 0 0-.627 2.283c0 1.575.821 2.967 2.062 3.782a4.6 4.6 0 0 1-2.099-.567v.056c0 2.204 1.594 4.036 3.703 4.454q-.598.158-1.216.159-.438 0-.868-.085c.587 1.805 2.294 3.118 4.315 3.155a9.36 9.36 0 0 1-6.835 1.88 13.06 13.06 0 0 0 7.066 2.053c8.501 0 13.146-6.923 13.146-12.928q0-.297-.015-.586a9.3 9.3 0 0 0 2.303-2.353"
  })));
};
export default SvgTwitter;